import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { from } from 'rxjs';
import { switchMap } from 'rxjs/operators';


interface VideoRecord {
  url: string;
  date: string;
  recorderName?: string
}
@Injectable({
  providedIn: 'root'
})
export class VideoService {

  private baseUrl: any = environment.baseUrl;
  private baseUrlStorage: any = environment.baseUrlStorage;
  // private baseUrl: any = environment.baseUrl;
  // private videoUrl:any=environment.videoUrl

  constructor(private http: HttpClient) { }


  private videoRecordsSubject = new BehaviorSubject<VideoRecord[]>([]);
  videoRecords$ = this.videoRecordsSubject.asObservable();


  private booleanSource = new BehaviorSubject<boolean>(false);
  boolean$ = this.booleanSource.asObservable();

  private pauserecord = new BehaviorSubject<boolean>(false);
  Pause = this.pauserecord.asObservable();
  private ResumeRecoed = new BehaviorSubject<boolean>(false);
  Resume = this.ResumeRecoed.asObservable();

  private isRecordingSubject = new BehaviorSubject<boolean>(false);
  isRecording$ = this.isRecordingSubject.asObservable();

  // Call this to read current value synchronously
  get isRecording(): boolean {
    return this.isRecordingSubject.value;
  }

  setRecordingState(value: boolean): void {
    this.isRecordingSubject.next(value);
  }

  ResumeRecording(value: boolean) {
    this.ResumeRecoed.next(value);
  }

  updateBoolean(value: boolean) {
    this.booleanSource.next(value);
  }
  PauseRecording(value: boolean) {
    this.pauserecord.next(value);
  }
  //   addVideoRecord(url: string, date: string) {
  //     const currentRecords = this.videoRecordsSubject.value;
  //     this.videoRecordsSubject.next([...currentRecords, { url, date }]); // Add new video record
  //   }

  // }
  // addVideoRecord(url: string, date: string, recorderName: string): void {
  //   const currentRecords = this.videoRecordsSubject.value;
  //   currentRecords.push({ url, date, recorderName }); // Add new video record with dynamic name
  //   // this.videoRecordsSubject.next(currentRecords); // Emit updated records
  //   this.videoRecordsSubject.next([...currentRecords]);

  // }
  addVideoRecord(url: string, date: string, recorderName: string): void {
    const currentRecords = [...this.videoRecordsSubject.value]; // Copy current records
    currentRecords.push({ url, date, recorderName });
    this.videoRecordsSubject.next(currentRecords); // Emit updated records
  }
  updateRecorderName(index: number, recorderName: string): void {
    const currentRecords = this.videoRecordsSubject.value;
    if (currentRecords[index]) {
      currentRecords[index].recorderName = recorderName; // Update recorder name
      this.videoRecordsSubject.next([...currentRecords]); // Emit updated records
    }
  }


  clearVideoRecords(): void {
    this.videoRecordsSubject.next([]); // Emit an empty array to clear records

  }
  uploadVideo(formData: FormData, emailId: any): Promise<any> {

    // / return this.http.post<any>("//localhost:5000",formData)
    return fetch(this.baseUrlStorage + '/file/upload', {
      method: 'POST',
      body: formData,
      mode: "cors"
    })
      // .then((response :any)=> 
      // alert(response.message)
      // )
      .then((response) => {
        if (!response.ok) {
          // Handle HTTP errors
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json(); // Parse the response JSON
      })
      .catch((error) => {
        console.error('Error uploading video:', error);
        throw error;
      });


  }
  removeDraftScreenRecord(email: any, videoName: any) {
    let formdata: any = {
      "bucket": "ProteanStorageVideo",
      "filePath": videoName
    };
    fetch(this.baseUrlStorage + '/file/removeFile', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formdata),
      mode: "cors"
    })

  }
  removeDraftScreenRecordAll(email: any) {
    let formdata: any = {
      "bucket": "ProteanStorageVideo",
      "folderPrefix": email
    };
    return from(fetch(this.baseUrlStorage + '/file/deleteCommonFile', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formdata),
      mode: "cors"
    })).pipe(
      switchMap(response => from(response.json()))
    );
  }
  // BackupScreenrecord(emailId:any) {


  //   fetch('http://localhost:5000/getListVideos/' + emailId, {
  //     method: 'GET',                
  //     headers: {
  //       'Content-Type': 'application/json',   
  //     },
  //     mode: 'cors'                   
  //   })
  // }
}